import {Component, AfterViewInit, ChangeDetectionStrategy, ViewChild, Input} from '@angular/core';
import {LySliderChange, STYLES as SLIDER_STYLES} from '@alyle/ui/slider';
import {ThemeVariables, ThemeRef, lyl, StyleRenderer} from '@alyle/ui';
import {
  STYLES as CROPPER_STYLES,
  LyImageCropper,
  ImgCropperConfig,
  ImgCropperEvent,
  ImgCropperErrorEvent,
  ImgCropperLoaderConfig,
  ImgResolution,
} from '@alyle/ui/image-cropper';
import {Platform} from '@angular/cdk/platform';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

const STYLES = (_theme: ThemeVariables, ref: ThemeRef) => {
  ref.renderStyleSheet(SLIDER_STYLES);
  ref.renderStyleSheet(CROPPER_STYLES);
  const slider = ref.selectorsOf(SLIDER_STYLES);
  const cropper = ref.selectorsOf(CROPPER_STYLES);

  return {
    root: lyl`{
      ${cropper.root} {
        max-width: 396px
        height: 290px
      }
      ${slider.root} {
        width: 100%
        max-width: 400px
        padding-left: 1em
        padding-right: 1em
      }
    }`,
    sliderContainer: lyl`{
      text-align: center
      max-width: 400px
      padding: 0 14px
      box-sizing: border-box
      min-width: 300px
    }`
  };
};

@Component({
    selector: 'app-full-cropper-width',
    templateUrl: './cropper.component.html',
    styleUrls: ['./cropper.component.scss'],
    providers: [
        StyleRenderer
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FullCropperWidthComponent implements AfterViewInit {
  @Input() title: string | undefined;
  @Input() cropAreaWidth: number = 396;
  @Input() cropAreaHeight: number = 290;
  @Input() cropperAlert : boolean = false;
  @Input() cropperAlertMessage : string = "";

  readonly classes = this.sRenderer.renderSheet(STYLES, 'root');
  croppedImage?: string;
  ready?: boolean;
  scale?: number;
  minScale: number = 10;
  maxScale: number = 100;
  @ViewChild(LyImageCropper) cropper?: LyImageCropper;
  myConfig: ImgCropperConfig = {
    width: 396,
    height: 290,
    keepAspectRatio: true,
    responsiveArea: true,
    output: ImgResolution.Default,
  };

  constructor(
    readonly sRenderer: StyleRenderer,
    private _platform: Platform,
    private activeModal: NgbActiveModal
  ) {
  }

  ngAfterViewInit() {
    if (this._platform.isBrowser) {
      const config: ImgCropperLoaderConfig = {
        rotation: 0,
        xOrigin: 3235.7749135491986,
        yOrigin: 1711.626216978359,
        scale: 0.11451599999999999,
        originalDataURL: ''
      };
      this.cropper?.loadImage(config);
    }
    this.updateCropperConfig(this.cropAreaWidth, this.cropAreaHeight);
  }

  onCropped(e: ImgCropperEvent) {
    this.croppedImage = e.dataURL;
  }

  onLoaded(e: ImgCropperEvent) {
    console.log('img loaded', e);
  }

  onError(e: ImgCropperErrorEvent) {
    console.warn(`'${e.name}' is not a valid image`, e);
  }

  onSliderInput(event: LySliderChange) {
    this.scale = event.value as number;
  }

  onConfirmClick(): void {
    if (this.croppedImage) {
      this.activeModal.close(this.croppedImage);
    } else {
      this.activeModal.close();
    }
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

  updateCropperConfig(width: number, height: number) {
    this.myConfig = {
      ...this.myConfig,
      width: width,
      height: height,
    };
  }
}
